import posthog from "posthog-js";

/**
 * Tracks an event in PostHog
 *
 * @param {string} eventName - The name of the event to track
 * @param {Object} properties - Additional properties to include with the event
 */
export const trackEvent = (eventName, properties = {}) => {
  try {
    if (posthog && typeof posthog.capture === "function") {
      posthog.capture(eventName, properties);
    }
  } catch (error) {
    console.error("Error tracking event:", error);
  }
};
